// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__35r_Y","inputWrap":"Table_inputWrap__1Y2Nv","col":"Table_col__3Izru","bmiTooltip":"Table_bmiTooltip__2fPjz"};